import { getRgObjectsOfType as r, RG_TYPE as t } from "@project-rouge/rg-core";
import { isMiscDoor as e } from "../../queries/index6.js";
const c = (o) => r(o, t.Door).filter(e).length;
export {
  c as getMiscDoorsCount
};
//# sourceMappingURL=index35.js.map
